import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "@/lib/settings";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ConfiguratorPage from "@/pages/ConfiguratorPage";
import ServicesPage from "@/pages/ServicesPage";
import ReviewsPage from "@/pages/ReviewsPage";
import BlogPage from "@/pages/BlogPage";
import AboutPage from "@/pages/AboutPage";
import ContactsPage from "@/pages/ContactsPage";
import AdminPanel from "@/pages/AdminPanel";

function Layout() {
    return (
        <>
            <Navbar />
            <Outlet />
            <Footer />
        </>
    );
}

function App() {
    return (
        <SettingsProvider>
            <BrowserRouter>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#09090b",
                            border: "1px solid rgba(255,255,255,0.1)",
                            color: "#fff",
                        },
                    }}
                />
                <Routes>
                    <Route path="/administrator-panel" element={<AdminPanel />} />
                    <Route element={<Layout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/catalog" element={<CatalogPage />} />
                        <Route path="/configurator" element={<ConfiguratorPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/reviews" element={<ReviewsPage />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contacts" element={<ContactsPage />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </SettingsProvider>
    );
}

export default App;
